module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("htp7C"))).then(() => parcelRequire('ikE14'));